<form class="content flex display-flex-column" #contentForm="ngForm" [resBusySpinner]="isBusy" [message]="isBusyMessage"
    data-automation-id="profile-modal-container">
    <div class='top-content no-flex'>
        <button type="button" class="primary-button search-profile-button"
            data-automation-id="profile-search-by-profile-button" (click)="openSearchByProfile()"
            [disabled]="isDirty || !profile.documentHandle">
            <i class="fa fa-search"></i>Search by Synthetic Document...
        </button>
        <button type="button" class="help-button" data-automation-id="profile-help-button" title="Help"
            aria-label="Help" (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>
    <div class='middle-content flex display-flex-column'>

        <div class="profile-row first-row flex">
            <div class="row-column-fix">
                <label [attr.data-automation-id]="'text-label-profile'" for="text">Synthetic Document text:
                </label>
            </div>
            <div class="row-column-max">
                <textarea id="text" class="profile-text" [(ngModel)]="profile.content" [value]="profile.content"
                    [disabled]="!hasProfilesPermissions" (ngModelChange)="onChanged()"
                    data-automation-id="profile-text-input" name="text"></textarea>
            </div>
        </div>
        <div class="profile-row row-padding-bottom no-flex" *ngIf="hasProfilesPermissions">
            <div class="row-column-fix">
                <label [attr.data-automation-id]="'comment-label-profile'" for="comment">Comment:
                </label>
            </div>
            <div class="row-column-max">
                <input type="text" id="comment" [(ngModel)]="profile.lastComments"
                    data-automation-id="profile-comment-input" (ngModelChange)="onChanged()" name="comment">
            </div>
        </div>

        <div class="profile-row no-flex" *ngIf="hasProfilesPermissions">
            <div class="row-column-fix">

            </div>
            <div class="row-column-max">
                <button type="button" class="primary-button margin-right-button"
                    data-automation-id="profile-save-button" (click)="saveChangesWithPromise()">
                    Save
                </button>
                <button type="button" class="secondary-button" data-automation-id="profile-discard-changes-button"
                    [disabled]="!isDirty" (click)="discardChangesProfileDetail()">
                    Discard Changes
                </button>
            </div>
        </div>
    </div>
</form>